import { ChannelStrip } from './ChannelStrip';
import { MasteringChain } from './MasteringChain';
import * as Tone from 'tone';

/**
 * EffectChain.js
 * Centralized Factory for Audio Effect Graphs.
 */

/**
 * Creates a new ChannelStrip instance.
 * @param {Object} source - Source synth or node.
 * @param {Object} mixTraits - Mix traits from InstrumentLibrary.
 * @param {Object} globalSends - Global send destinations { reverb, delay }.
 * @returns {ChannelStrip}
 */
export const createChannelStrip = (source, mixTraits, globalSends) => {
    return new ChannelStrip(source, mixTraits, globalSends);
};

/**
 * Creates a new MasteringChain instance.
 * Includes Bus Compressor for glue.
 * @returns {MasteringChain}
 */
export const createMasteringChain = () => {
    return new MasteringChain();
};
